import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationInfoModel } from '../models/application-info.model';
import { environment } from '../../environments/environment';
import { AlertMessagesConfig } from 'config/alert-messages.config';

import { catchError, map, Observable, throwError } from 'rxjs';

export type ApplicationInfoModelResponse = {
  data: ApplicationInfoModel
}

export type ApplicationInfoModelArrayResponse = {
  data: ApplicationInfoModel[]
}
export type RetrieveApplResponse = {
  Data: ApplicationInfoModel[];
  Errors: [],
  ErrorMessage: string
}
export interface RetrieveApplRequest {
  sysparm_query? :string;
  orgId:string;
  ssoId:string;
  email?:string;
  status:string[];
	formType?:string;
  caseSysId?:string;
}
export interface IApplicationInfoService {
}
@Injectable({
  providedIn: 'root'
})

export class ApplicationInfoService implements IApplicationInfoService {
  readonly defaultServerError =  'We\'re having trouble connecting to our server. Try reloading or checking your internet connection.';
  // private apiUrl = environment.apiUrl;
  
  constructor(private http: HttpClient,
    public alertsMessageConfig: AlertMessagesConfig,
  ) { }

  public fetchApplicationsByStatus(req: RetrieveApplRequest): Observable<RetrieveApplResponse> {
   return this.http.post<any>('usanapi/dashboard/applicant', req)
    // return this.http.post<any>(this.apiUrl + '/dashboard/applicant', req)
     .pipe(
        map(response => {
          return response;
        }),
        catchError(() => {
          return throwError(() => new Error(this.alertsMessageConfig.defaultServerError));
        }));
  }
  public deleteApplication(req: any): Observable<RetrieveApplResponse> {
    return this.http.post<any>('usanapi/remove-case', req)
     .pipe(
        map(response => {
          return response;
        }),
        catchError(() => {
          return throwError(() => new Error(this.alertsMessageConfig.defaultServerError));
        }));
  }

  public mapToApplicationModelArray(data, status): ApplicationInfoModel[] {
    const array: ApplicationInfoModel[] = [];
   const dataForStatus = data.filter(row => row.u_case_status.toLowerCase() === status.toLowerCase());
    for(const d of dataForStatus) {
        array.push(ApplicationInfoModel.parseAPIValues(d));
    }
    return array;
  }

}
